import { render, staticRenderFns } from "./CompanyDetailsRegister.vue?vue&type=template&id=0d230a73&"
import script from "./CompanyDetailsRegister.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports